import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./toggle-widget.html';

    function ToggleWidget(params) {

        var self = this;

        self.value = ko.observable(params.value);

        self.trueText = params.trueText;

        self.falseText = params.falseText;

        self.text = ko.observable(self.value() ? self.trueText : self.falseText);
        self.activeClass = ko.observable(self.value() ? ' active' : '');

        self.showLoader = ko.observable(false);

        self.value.subscribe(function() {

            self.text(self.value() ? self.trueText : self.falseText);
            self.activeClass(self.value() ? ' active' : '');

        });

        self.clicked = function() {

            self.showLoader(true);
            return true;
        };

    }

    ToggleWidget.prototype.dispose = function () {
    };

    export default {
        viewModel:ToggleWidget, template: templateMarkup
    };


